import { render, staticRenderFns } from "./ReferenceSidebar.vue?vue&type=template&id=cf2ea57a&"
import script from "./ReferenceSidebar.vue?vue&type=script&lang=js&"
export * from "./ReferenceSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceSidebar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports